module.exports = __webpack_public_path__ + "img/szw5.4681b27c.jpg";